import { CLEAR_PAGE } from '../base/types';
import { FETCH_CALLBACKS } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: []
};

const callbacksReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_CALLBACKS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_CALLBACKS}_FULFILLED`:
      console.log('payload', payload);
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_CALLBACKS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'callbacks' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default callbacksReducer;
